import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=9a2ea534&scoped=true&"
import script from "./BookingStatus.vue?vue&type=script&lang=ts&"
export * from "./BookingStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BookingStatus.vue?vue&type=style&index=0&id=9a2ea534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2ea534",
  null
  
)

export default component.exports